import React, { FunctionComponent } from 'react';

import BarHeaderLayout from '@/pages/layouts/BarHeaderLayout';
import DestinationRegionPage from '@/components/pageComponents/DestinationRegionPage';
import { getRegion } from '@/pageGeneration/services/prismicApi/landingPageDestinationsApi';
import PageSeo from '@/components/seo/PageSeo';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import mapResultsToIndexPageItems from '@/pageGeneration/services/mapResultsToIndexPageItems';
import useCustomPageViews from '@/utility/eventTracking/useCustomPageViews';
import { PAGE_CATEGORIES } from '@/utility/eventTracking/constants';
import UnprotectedPage from '@/components/navigation/UnprotectedPage';
import { getAirportsForRegion } from '@/pageGeneration/services/prismicApi/landingPageAirportApi';
import LandingPageService, { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';
import RouteHelper from '@jetslash/market-frontend-shared-core/src/utilities/navigation/RouteHelper';

interface IProps {
  items: ILandingPageLink[];
  region: string;
  regionName: string;
}

const AirportsRegion: FunctionComponent<IProps> = ({ items, region, regionName }) => {
  useCustomPageViews({ category: PAGE_CATEGORIES.AIRPORTS, name: `List/${region}` });

  const title = `Airports (${regionName})`;
  return (
    <UnprotectedPage>
      <PageSeo title={title} noIndex />
      <BarHeaderLayout>
        <DestinationRegionPage items={items} title={title} />
      </BarHeaderLayout>
    </UnprotectedPage>
  );
};

export default AirportsRegion;

export async function getStaticProps({ params }: { params: { region: string } }) {
  try {
    const regionParam = params.region;
    if (!LandingPageService.isValidRegionSlug(regionParam)) {
      return {
        notFound: true,
      };
    }
    const regionUid = regionParam.toLowerCase();
    console.log(`Get Airport Region: ${regionUid}`);
    const regionResponse = await getRegion(regionUid);
    if (!regionResponse || !regionResponse.results.length) {
      return {
        notFound: true,
      };
    }
    const regionData = regionResponse.results[0].data;

    const results = await getAirportsForRegion(regionUid);
    const items = mapResultsToIndexPageItems(results, `${RouteHelper.airportRegionPath(params.region)}/`, true);

    return packageStaticProps({
      items,
      regionName: regionData.name,
      region: regionParam,
    });
  } catch (e) {
    console.log(`Airport region error ${params.region}`);
    console.log(e);
    return {
      notFound: true,
    };
  }
}

export async function getStaticPaths() {
  return {
    fallback: 'blocking',
    paths: [],
  };
}
